import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DatePickerMeta: ComponentMeta = {
  componentName: "DatePicker",
  package: "@mijadesign/web",
  title: "日期选择器",
  description: "输入或选择日期的控件",
  category: ComponentCategory.FORM,
  icon: "CalendarOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "选择日期",
      group: "基础",
    },
    {
      name: "format",
      label: "日期格式",
      type: PropType.STRING,
      defaultValue: "YYYY-MM-DD",
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "disabledDate",
      label: "禁用日期",
      type: PropType.STRING,
      description:
        "禁用的日期，如：(currentDate) => currentDate && currentDate.valueOf() < Date.now()",
      group: "高级",
    },
    {
      name: "showTime",
      label: "显示时间",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "bordered",
      label: "边框",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
  ],
  defaultProps: {
    placeholder: "选择日期",
    format: "YYYY-MM-DD",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "DatePicker",
  },
  snippet: {
    componentName: "DatePicker",
    package: "@mijadesign/web",
    props: { placeholder: "选择日期" },
  },
};

export const RangePickerMeta: ComponentMeta = {
  componentName: "DatePicker.RangePicker",
  package: "@mijadesign/web",
  title: "日期范围选择器",
  description: "选择日期范围的控件",
  category: ComponentCategory.FORM,
  icon: "CalendarOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.ARRAY,
      defaultValue: ["开始日期", "结束日期"],
      group: "基础",
    },
    {
      name: "format",
      label: "日期格式",
      type: PropType.STRING,
      defaultValue: "YYYY-MM-DD",
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "showTime",
      label: "显示时间",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
  ],
  defaultProps: {
    placeholder: ["开始日期", "结束日期"],
    format: "YYYY-MM-DD",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "DatePicker",
  },
  snippet: {
    componentName: "DatePicker.RangePicker",
    package: "@mijadesign/web",
    props: { placeholder: ["开始日期", "结束日期"] },
  },
};

export const TimePickerMeta: ComponentMeta = {
  componentName: "TimePicker",
  package: "@mijadesign/web",
  title: "时间选择器",
  description: "输入或选择时间的控件",
  category: ComponentCategory.FORM,
  icon: "ClockCircleOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "选择时间",
      group: "基础",
    },
    {
      name: "format",
      label: "时间格式",
      type: PropType.STRING,
      defaultValue: "HH:mm:ss",
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "hourStep",
      label: "小时步长",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "步长",
    },
    {
      name: "minuteStep",
      label: "分钟步长",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "步长",
    },
    {
      name: "secondStep",
      label: "秒步长",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "步长",
    },
  ],
  defaultProps: {
    placeholder: "选择时间",
    format: "HH:mm:ss",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "TimePicker",
  },
  snippet: {
    componentName: "TimePicker",
    package: "@mijadesign/web",
    props: { placeholder: "选择时间" },
  },
};
